import { UtilityService } from 'src/app/_services/utility.service';
import { AuthService } from './../../_services/auth.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { Observable } from 'rxjs';
import { ProfileService } from 'src/app/_services/profile.service';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
import { MediaMatcher } from '@angular/cdk/layout';
import { LoaderService } from 'src/app/_services/services/loader.service';
import { SidebarService } from 'src/app/_services/sidenav.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit, OnDestroy {
  userRole!: string;
  sidenav!: HTMLElement;
  toggler!: HTMLElement;
  profilePic: string = '';
  sidenavClosed$!: Observable<boolean>;
  isSidenavClosed: boolean = false;
  checkUrl: any;
  role: any;
  notification: any;
  isSidebarHovered: boolean = false;

  enableDragDrop: boolean = true;
  path: string;

  logo: any;
  navigationSubscription: any;
  hobbyNotification: any;

  lastSegment: string = '';

  isMobile: boolean;
  isDesktop: boolean;
  mediaQueryList: MediaQueryList;

  private readonly mobileQueryListener: () => void;
  argument_route: string;

  constructor(
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    private readonly authService: AuthService,
    private readonly sanitizer: DomSanitizer,
    private readonly profileService: ProfileService,
    private readonly titleService: UtilityService,
    private readonly mediaMatcher: MediaMatcher,
    public readonly sidebarService: SidebarService,
    public loaderService: LoaderService
  ) {
    this.profileService.getImg();

    const mediaQuery = '(max-width: 767px)';

    this.mobileQueryListener = () => {
      this.isMobile = this.mediaMatcher.matchMedia(mediaQuery).matches;
      this.isDesktop = !this.isMobile;
    };

    const mediaQueryList = this.mediaMatcher.matchMedia(mediaQuery);
    mediaQueryList.addEventListener('change', this.mobileQueryListener);
    this.mobileQueryListener();

    this.mediaQueryList = mediaMatcher.matchMedia('(max-width: 767px)');
    this.mediaQueryList.addEventListener('change', event => {
      this.onMediaQueryChange(event.matches);
    });

    this.onMediaQueryChange(this.mediaQueryList.matches);
  }

  ngOnInit(): void {
    const urlSegments = this.route.snapshot.url;
    if (urlSegments.length > 1) {
      this.argument_route = urlSegments[1].path;
      this.titleService.setTitle(this.argument_route.replace(/-/g, ' '));
    } else {
      // Gestione alternativa nel caso in cui non ci siano segmenti sufficienti nell'URL
      this.argument_route = 'Default Title';
      this.titleService.setTitle(this.argument_route);
    }

    // Aggiungi questo codice per nascondere la sidebar2 quando viene caricata una nuova pagina
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const sidebar = document.querySelector('.sidebar2');
        if (sidebar) {
          sidebar.classList.remove('show');
        }
      }
    });
  }

  ngAfterViewInit() {
    this.sidenav = document.querySelector('.sidebar')!;
    this.sidenavClosed$ = this.sidebarService.getSidenavClosed();
    this.sidenavClosed$.subscribe(isSidebarClosed => {
      this.isSidenavClosed = isSidebarClosed;
      this.checkWindowWidth();
    });
  }

  logout(): void {
    this.authService.logout().subscribe(res => {
      this.router.navigate(['/login']);
    });
  }

  getSantizeUrl(url: string) {
    this.path = environment.file + url;

    return this.sanitizer.bypassSecurityTrustUrl(this.path);
  }

  ngOnDestroy() {
    if (this.navigationSubscription) {
      this.navigationSubscription.unsubscribe();
    }

    this.mediaQueryList.removeEventListener('change', () => {});
  }

  toggleSidebar(): void {
    const sidebar = document.querySelector('.sidebar2');
    if (sidebar) {
      sidebar.classList.toggle('show');
    }
  }

  // Metodo per controllare la larghezza della finestra e nascondere la sidebar2 se necessario
  checkWindowWidth(): void {
    window.onresize = () => {
      if (window.innerWidth > 767) {
        const sidebar = document.querySelector('.sidebar2');
        if (sidebar) sidebar.classList.remove('show');
      }
    };
  }

  /*getLastSegment(url: string): string {
    const segments = url.split('/');
    const lastSegment = segments[segments.length - 1];

    // Verifica se l'ultimo segmento è un numero
    if (!isNaN(Number(lastSegment))) {
      // Se è un numero, restituisci il segmento precedente
      const penultimateSegment = segments[segments.length - 2];
      return penultimateSegment.replace(/-/g, ' ').toUpperCase(); // Sostituisci tutti i trattini con spazi
    } else {
      // Altrimenti, restituisci l'ultimo segmento
      return lastSegment.replace(/-/g, ' ').toUpperCase(); // Sostituisci tutti i trattini con spazi
    }
  } */

  onMediaQueryChange(matches: boolean): void {
    this.isMobile = matches;
    // Chiude la sidebar quando si passa alla modalità mobile
    if (this.isMobile) {
      this.isSidenavClosed = false;
    }
  }

  handleSidebarHover(isHovered: boolean) {
    this.isSidebarHovered = isHovered;
  }
}
